import { ColumnDescriptorProps } from '../../../../../components/table/ListTable';
import Button from '@rio-cloud/rio-uikit/Button';
import { FormattedMessage } from 'react-intl';
import { FileDownloader } from '../../upload/journal/FileDownloader';
import React from 'react';
import { useLazyGetCsvFileQuery } from '../../../../../services/connectivityInterruptionApi';
import saveAs from 'file-saver';
import Notification from '@rio-cloud/rio-uikit/Notification';
import { VinBlacklistModel } from './InterruptionVinUpload';

export enum EActionType {
    BLACKLIST = 'BLACKLIST',
    WHITELIST = 'WHITELIST',
}

export const columnDescriptorsLists = (
    onShowConfirmation: (action: EActionType, item: VinBlacklistModel) => void,
): ColumnDescriptorProps<VinBlacklistModel>[] => {
    const DownloadCell = ({ field }: { field?: string }) => {
        const [triggerDownload, { data, error }] = useLazyGetCsvFileQuery();

        React.useEffect(() => {
            if (data && field) {
                const blob =
                    data instanceof Blob
                        ? data
                        : new Blob([data], { type: 'text/csv;charset=utf-8;' });
                saveAs(blob, field);
            }
        }, [data, field]);

        React.useEffect(() => {
            if (error) {
                Notification.error('Download failed.');
            }
        }, [error]);

        if (!field) return null;

        return (
            <>
                <FileDownloader
                    className="padding-right-5"
                    filename={field}
                    downloadMethod={() => triggerDownload(field)}
                />
                <span>{field}</span>
            </>
        );
    };

    return [
        {
            id: 'listName',
            field: 'listName',
            label: 'VIN Filename',
            format: field => <DownloadCell field={field} />,
        },
        {
            id: 'listNameVinImsi',
            field: 'listNameVinImsi',
            label: 'VIN IMSI Filename',
            format: field => <DownloadCell field={field} />,
        },
        {
            id: 'requester',
            field: 'requester',
            label: 'Requester',
            format: field => <span>{field}</span>,
        },
        {
            id: 'action-blacklist',
            field: 'action',
            label: 'Blacklist',
            format: (_, item) => (
                <Button
                    onClick={() => onShowConfirmation(EActionType.BLACKLIST, item!)}
                    disabled={!(item?.action === 'UPLOAD' || item?.action === 'WHITELIST')}
                >
                    <FormattedMessage id="intl-msg:coreconAdminWeb.connectivityInterruption.blacklist" />
                </Button>
            ),
        },
        {
            id: 'action-whitelist',
            field: 'action',
            label: 'Whitelist',
            format: (_, item) => (
                <Button
                    onClick={() => onShowConfirmation(EActionType.WHITELIST, item!)}
                    disabled={item?.action !== 'BLACKLIST'}
                >
                    <FormattedMessage id="intl-msg:coreconAdminWeb.connectivityInterruption.whitelist" />
                </Button>
            ),
        },
    ];
};